import script from "./ConceptoEliminacionModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ConceptoEliminacionModal.vue?vue&type=script&setup=true&lang=js"

import "./ConceptoEliminacionModal.vue?vue&type=style&index=0&id=65956166&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65956166"]])

export default __exports__